import { j as t } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { Alert as a } from "@mui/joy";
import { memo as l } from "react";
import { S as o } from "../../../../../../index.B-E4PB3F.js";
const r = l(({
  syncDirection: e
}) => /* @__PURE__ */ t.jsx(a, { children: e === o.IMPORT ? null : e === o.EXPORT ? "This will export the selected dataset directly as First- and Third-party audience to GoogleDV360. The dataset should have only one column with plain email addressed that will be automatically hashed with SHA256. Note: Please access your GoogleDV360 account to verify the created audience." : null }));
r.displayName = "GoogleDV360Info";
export {
  r as default
};
//# sourceMappingURL=GoogleDV360Info.js.map
